import React, { useEffect, useState } from 'react'
import { Select } from '../../../ui'
import { useStore } from '../../../StateProvider'
import { equals, map } from 'ramda'
import { useTranslation } from 'react-i18next'
import { getOptions, getUserValue } from '../utils'
import { fetchCommissionUnits } from '../../api'
import { usePresetValue } from '../../utils/hooks'

const PER_DEAL = 'D'
const PER_LOT = 'L'
const USD_UNITS = 'USD'

/**
 * @param {string} label
 * @param {string} name
 * @param {string} additionalInfo
 */
const ExternalCommissionUnitsSelect = ({ label, name, additionalInfo }) => {
  const { t, i18n } = useTranslation()
  const [value, setValue] = useState('')
  const [fullList, setFullList] = useState([])
  const [list, setList] = useState([])
  const [isValid, setIsValid] = useState(null)
  const [{ user, form, form: { accId } }, dispatch] = useStore()
  const userValue = getUserValue(accId, user, name)
  const { commissionType } = form[accId]

  useEffect(() => {
    fetchCommissionUnits()
      .then(
        /**
         * @param {OptionsInput[]} units
         */
        (units) => {
          setFullList(getOptions(units))
        })
  }, [i18n.language])

  useEffect(() => {
    if (!commissionType) {
      setList(fullList)
    } else if (commissionType === PER_LOT) {
      setList(fullList.filter((unit) => unit.value !== USD_UNITS))
    } else if (commissionType === PER_DEAL) {
      setList(fullList.filter((unit) => unit.value === USD_UNITS))
    }
  }, [fullList, commissionType])

  useEffect(() => {
    if (value && !list.find((unit) => unit.value === value)) {
      presetValue('')
    }
  }, [value, list])

  /**
   * @param {string} value
   */
  const getSelectValue = (value) => (equals(value, t('generatedField.choose')) ? '' : value)

  /**
   * @param {string} value
   */
  const presetValue = (value) => {
    const stringValue = value.toString()
    setValue(stringValue)
    const isValid = stringValue.length > 0
    setIsValid(isValid)
    dispatch({
      type: 'setExtFieldValue',
      name,
      value: value
    })
    dispatch({ type: 'setValidationFld', name, value: isValid })
  }

  usePresetValue(name, userValue, presetValue)

  /**
   * @param {{target: {value: string, name: string}}} props
   */
  const onChange = ({ target: { value, name } }) => {
    const selectedValue = getSelectValue(value)
    setValue(selectedValue)
    setIsValid(selectedValue.length > 0)
    dispatch({
      type: 'setExtFieldValue',
      name,
      value: selectedValue
    })
    dispatch({ type: 'setValidationFld', name, value: selectedValue.length > 0 })
  }

  return (
    <Select
      value={value || ''}
      label={t(label)}
      placeholder={t('generatedField.choose')}
      options={list}
      onChange={onChange}
      name={name}
      key={name}
      error=''
      valid={isValid}
      info={additionalInfo ? t(`generatedField.${name}AdditionalInfo`) : ''}
    />)
}

const getExternalCommissionUnitsSelectFields = map(currencyField => {
  const { i18n, name, required, order, dependOnBooleanFldName } = currencyField
  return (
    <ExternalCommissionUnitsSelect
      label={i18n ? `generatedField.${i18n}` : ''}
      name={name}
      required={required}
      key={name}
      order={order}
      dependOnBooleanFldName={dependOnBooleanFldName}
    />
  )
})

export { ExternalCommissionUnitsSelect, getExternalCommissionUnitsSelectFields }
